export const PlusIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      marginleft="5px"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="white" />
      <path
        d="M10.88 5.16C10.88 4.68 10.49 4.29 10 4.29C9.51 4.29 9.12 4.68 9.12 5.16V9.12H5.16C4.68 9.12 4.29 9.51 4.29 10C4.29 10.49 4.68 10.88 5.16 10.88H9.12V14.84C9.12 15.32 9.51 15.71 10 15.71C10.49 15.71 10.88 15.32 10.88 14.84V10.88H14.84C15.32 10.88 15.71 10.49 15.71 10C15.71 9.51 15.32 9.12 14.84 9.12H10.88V5.16Z"
        fill="#104581"
      />
    </svg>
  );
};

export const BackArrow = ({ color }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 30C23.28 30 30 23.28 30 15C30 6.72 23.28 0 15 0C6.72 0 0 6.72 0 15C0 23.28 6.72 30 15 30Z"
        fill="#104581"
      />
      <path
        d="M20.31 15H9.69"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9.69L9.69 15L15 20.31"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = ({ color }) => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.09 1.81L5.41 2.81H10.59L9.91 1.81C9.86 1.74 9.77 1.69 9.67 1.69H6.33C6.23 1.69 6.14 1.73 6.09 1.81H6.09ZM11.34 0.88L12.65 2.81H13.14H14.86H15.14C15.62 2.81 16 3.19 16 3.66C16 4.12 15.62 4.5 15.14 4.5H14.86V15.19C14.86 16.74 13.58 18 12 18H4C2.42 18 1.14 16.74 1.14 15.19V4.5H0.86C0.38 4.5 0 4.12 0 3.66C0 3.19 0.38 2.81 0.86 2.81H1.14H2.86H3.35L4.66 0.88C5.03 0.33 5.66 0 6.33 0H9.67C10.34 0 10.96 0.33 11.34 0.88L11.34 0.88ZM2.86 4.5V15.19C2.86 15.81 3.37 16.31 4 16.31H12C12.63 16.31 13.14 15.81 13.14 15.19V4.5H2.86ZM5.71 6.75V14.06C5.71 14.37 5.46 14.63 5.14 14.63C4.83 14.63 4.57 14.37 4.57 14.06V6.75C4.57 6.44 4.83 6.19 5.14 6.19C5.46 6.19 5.71 6.44 5.71 6.75ZM8.57 6.75V14.06C8.57 14.37 8.31 14.63 8 14.63C7.69 14.63 7.43 14.37 7.43 14.06V6.75C7.43 6.44 7.69 6.19 8 6.19C8.31 6.19 8.57 6.44 8.57 6.75ZM11.43 6.75V14.06C11.43 14.37 11.17 14.63 10.86 14.63C10.54 14.63 10.29 14.37 10.29 14.06V6.75C10.29 6.44 10.54 6.19 10.86 6.19C11.17 6.19 11.43 6.44 11.43 6.75Z"
        fill="#FF3C3C"
      />
    </svg>
  );
};

export const EditIcons = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.62 1.95L16.05 2.38C16.39 2.71 16.39 3.25 16.05 3.58L15.02 4.61L13.39 2.98L14.42 1.95C14.75 1.62 15.29 1.62 15.62 1.95ZM7.43 8.94L12.19 4.18L13.82 5.81L9.06 10.57C8.96 10.67 8.83 10.74 8.69 10.78L6.62 11.38L7.21 9.3C7.25 9.16 7.33 9.04 7.43 8.93V8.94ZM13.22 0.75L6.23 7.73C5.92 8.04 5.7 8.42 5.58 8.84L4.57 12.38C4.48 12.68 4.56 12.99 4.78 13.21C5 13.43 5.32 13.52 5.62 13.43L9.16 12.42C9.58 12.3 9.96 12.07 10.26 11.77L17.25 4.78C18.25 3.79 18.25 2.17 17.25 1.18L16.82 0.75C15.83 -0.25 14.21 -0.25 13.22 0.75ZM3.12 2.13C1.4 2.13 0 3.52 0 5.25V14.88C0 16.6 1.4 18 3.12 18H12.75C14.48 18 15.87 16.6 15.87 14.88V10.91C15.87 10.44 15.49 10.06 15.02 10.06C14.55 10.06 14.17 10.44 14.17 10.91V14.88C14.17 15.67 13.54 16.3 12.75 16.3H3.12C2.33 16.3 1.7 15.67 1.7 14.88V5.25C1.7 4.46 2.33 3.83 3.12 3.83H7.09C7.56 3.83 7.94 3.45 7.94 2.98C7.94 2.51 7.56 2.13 7.09 2.13H3.12Z"
        fill="#838383"
      />
    </svg>
  );
};

export const ViewIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.61C6.96 1.61 5.29 2.6 4 3.87C2.8 5.07 1.97 6.5 1.54 7.5C1.97 8.5 2.8 9.93 4 11.13C5.29 12.4 6.96 13.39 9 13.39C11.04 13.39 12.71 12.4 13.99 11.13C15.2 9.93 16.03 8.5 16.45 7.5C16.03 6.5 15.2 5.07 14 3.87C12.71 2.6 11.04 1.61 9 1.61ZM2.98 2.7C4.45 1.23 6.47 0 9 0C11.52 0 13.54 1.23 15.02 2.7C16.48 4.16 17.46 5.89 17.92 7.09C18.03 7.35 18.03 7.65 17.92 7.91C17.46 9.11 16.48 10.85 15.02 12.3C13.54 13.77 11.52 15 9 15C6.47 15 4.45 13.77 2.98 12.3C1.52 10.85 0.54 9.11 0.08 7.91C-0.03 7.65 -0.03 7.35 0.08 7.09C0.54 5.89 1.52 4.15 2.98 2.7ZM9 10.18C10.38 10.18 11.5 8.98 11.5 7.5C11.5 6.02 10.38 4.82 9 4.82C8.98 4.82 8.96 4.82 8.94 4.82C8.98 4.99 9 5.17 9 5.36C9 6.54 8.1 7.5 7 7.5C6.83 7.5 6.66 7.48 6.5 7.43C6.5 7.46 6.5 7.48 6.5 7.5C6.5 8.98 7.62 10.18 9 10.18ZM9 3.21C10.06 3.21 11.08 3.67 11.83 4.47C12.58 5.27 13 6.36 13 7.5C13 8.64 12.58 9.73 11.83 10.53C11.08 11.33 10.06 11.79 9 11.79C7.94 11.79 6.92 11.33 6.17 10.53C5.42 9.73 5 8.64 5 7.5C5 6.36 5.42 5.27 6.17 4.47C6.92 3.67 7.94 3.21 9 3.21Z"
        fill={color || "#838383"}
      />
    </svg>
  );
};

export const PswdvisibleIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.61C6.96 1.61 5.29 2.6 4 3.87C2.8 5.07 1.97 6.5 1.54 7.5C1.97 8.5 2.8 9.93 4 11.13C5.29 12.4 6.96 13.39 9 13.39C11.04 13.39 12.71 12.4 13.99 11.13C15.2 9.93 16.03 8.5 16.45 7.5C16.03 6.5 15.2 5.07 14 3.87C12.71 2.6 11.04 1.61 9 1.61ZM2.98 2.7C4.45 1.23 6.47 0 9 0C11.52 0 13.54 1.23 15.02 2.7C16.48 4.16 17.46 5.89 17.92 7.09C18.03 7.35 18.03 7.65 17.92 7.91C17.46 9.11 16.48 10.85 15.02 12.3C13.54 13.77 11.52 15 9 15C6.47 15 4.45 13.77 2.98 12.3C1.52 10.85 0.54 9.11 0.08 7.91C-0.03 7.65 -0.03 7.35 0.08 7.09C0.54 5.89 1.52 4.15 2.98 2.7ZM9 10.18C10.38 10.18 11.5 8.98 11.5 7.5C11.5 6.02 10.38 4.82 9 4.82C8.98 4.82 8.96 4.82 8.94 4.82C8.98 4.99 9 5.17 9 5.36C9 6.54 8.1 7.5 7 7.5C6.83 7.5 6.66 7.48 6.5 7.43C6.5 7.46 6.5 7.48 6.5 7.5C6.5 8.98 7.62 10.18 9 10.18ZM9 3.21C10.06 3.21 11.08 3.67 11.83 4.47C12.58 5.27 13 6.36 13 7.5C13 8.64 12.58 9.73 11.83 10.53C11.08 11.33 10.06 11.79 9 11.79C7.94 11.79 6.92 11.33 6.17 10.53C5.42 9.73 5 8.64 5 7.5C5 6.36 5.42 5.27 6.17 4.47C6.92 3.67 7.94 3.21 9 3.21Z"
        fill="#00A660"
      />
    </svg>
  );
};

export const ContactIcon = ({ color }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.83 0.72C4.61 0.18 4.01 -0.11 3.44 0.04L0.86 0.74C0.35 0.89 0 1.35 0 1.88C0 9.12 5.88 15 13.12 15C13.65 15 14.11 14.65 14.26 14.14L14.96 11.56C15.11 10.99 14.82 10.39 14.28 10.17L11.47 9C10.99 8.8 10.44 8.94 10.11 9.34L8.93 10.78C6.86 9.81 5.19 8.14 4.22 6.07L5.66 4.89C6.06 4.56 6.2 4.01 6 3.54L4.83 0.72V0.72Z"
        fill="#104581"
      />
    </svg>
  );
};

export const MessageIcon = ({ color }) => {
  return (
    <svg
      width="15"
      height="10"
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41 0C0.63 0 0 0.56 0 1.25C0 1.64 0.21 2.01 0.56 2.25L6.94 6.5C7.27 6.72 7.73 6.72 8.06 6.5L14.44 2.25C14.79 2.01 15 1.64 15 1.25C15 0.56 14.37 0 13.59 0H1.41ZM0 2.92V8.33C0 9.25 0.84 10 1.88 10H13.13C14.16 10 15 9.25 15 8.33V2.92L8.63 7.17C7.96 7.61 7.04 7.61 6.38 7.17L0 2.92Z"
        fill="#104581"
      />
    </svg>
  );
};

export const DownloadIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.64 15.55V12.27C19.64 12.06 19.55 11.85 19.4 11.69C19.24 11.54 19.04 11.45 18.82 11.45C18.6 11.45 18.39 11.54 18.24 11.69C18.09 11.85 18 12.06 18 12.27V15.55C18 15.76 17.91 15.97 17.76 16.12C17.61 16.28 17.4 16.36 17.18 16.36H2.45C2.24 16.36 2.03 16.28 1.88 16.12C1.72 15.97 1.64 15.76 1.64 15.55V12.27C1.64 12.06 1.55 11.85 1.4 11.69C1.24 11.54 1.04 11.45 0.82 11.45C0.6 11.45 0.39 11.54 0.24 11.69C0.09 11.85 0 12.06 0 12.27V15.55C0 16.2 0.26 16.82 0.72 17.28C1.18 17.74 1.8 18 2.45 18H17.18C17.83 18 18.46 17.74 18.92 17.28C19.38 16.82 19.64 16.2 19.64 15.55ZM14.42 11.27L10.33 14.55C10.18 14.66 10 14.72 9.82 14.72C9.63 14.72 9.46 14.66 9.31 14.55L5.22 11.27C5.07 11.13 4.98 10.94 4.97 10.74C4.95 10.53 5.01 10.33 5.14 10.17C5.27 10.01 5.45 9.9 5.65 9.87C5.86 9.84 6.06 9.88 6.23 10L9 12.21V0.82C9 0.6 9.09 0.39 9.24 0.24C9.39 0.09 9.6 0 9.82 0C10.04 0 10.24 0.09 10.4 0.24C10.55 0.39 10.64 0.6 10.64 0.82V12.21L13.4 10C13.48 9.92 13.58 9.86 13.69 9.82C13.8 9.78 13.91 9.77 14.02 9.78C14.13 9.79 14.24 9.82 14.35 9.87C14.45 9.92 14.53 10 14.6 10.08C14.67 10.17 14.73 10.28 14.75 10.38C14.78 10.49 14.79 10.61 14.77 10.72C14.75 10.83 14.71 10.94 14.65 11.03C14.59 11.13 14.51 11.21 14.42 11.27Z"
        fill="#104581"
      />
    </svg>
  );
};

export const UserFillIcon = () => {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="55" height="55" rx="8" fill="#104581" />
      <path
        d="M23.26 26.87C23.75 27.86 24.39 28.69 25.11 29.29C25.89 29.93 26.73 30.27 27.61 30.31H27.71C28.5 30.31 29.32 29.96 30.14 29.28C30.86 28.69 31.5 27.86 31.98 26.87C32.39 26.51 34.01 25.03 33.89 23.82C33.86 23.57 33.76 23.23 33.4 22.95C33.47 22.14 33.52 19.75 32.05 18.04C31.05 16.89 29.56 16.3 27.62 16.3C26.65 16.3 25.8 16.45 25.06 16.74C24.32 17.03 23.7 17.46 23.2 18.04C21.73 19.75 21.78 22.14 21.84 22.95C21.49 23.23 21.39 23.57 21.36 23.82C21.24 25.03 22.85 26.51 23.26 26.87ZM22.45 23.59C23.53 23.53 24.14 22.79 24.68 22.13C25.15 21.56 25.55 21.07 26.18 21.07C26.76 21.07 27.41 21.48 28.17 21.95C29.32 22.67 30.76 23.56 32.8 23.6C32.97 23.71 33.02 23.82 33.03 23.91C33.09 24.51 32.08 25.65 31.36 26.26C31.31 26.3 31.27 26.35 31.24 26.41C30.8 27.32 30.24 28.08 29.59 28.61C28.89 29.19 28.24 29.46 27.64 29.44C26.95 29.41 26.29 29.13 25.66 28.61C25.01 28.08 24.44 27.32 24 26.41C23.98 26.35 23.94 26.3 23.89 26.26C23.16 25.65 22.16 24.52 22.22 23.91C22.23 23.82 22.28 23.7 22.45 23.59Z"
        fill="white"
      />
      <path
        d="M18.83 38H36.41C36.65 38 36.85 37.8 36.85 37.57C36.85 33.98 34.56 30.82 31.16 29.7C30.96 29.63 30.73 29.72 30.63 29.91C30.27 30.6 29.02 32.41 27.62 32.68C25.94 32.36 24.62 29.93 24.61 29.91C24.51 29.72 24.29 29.63 24.09 29.7C20.69 30.82 18.4 33.98 18.4 37.57C18.4 37.8 18.6 38 18.83 38ZM31.4 34.46H32.1V33.75C32.1 33.51 32.3 33.32 32.54 33.32C32.78 33.32 32.97 33.51 32.97 33.75V34.46H33.68C33.92 34.46 34.11 34.65 34.11 34.89C34.11 35.13 33.92 35.32 33.68 35.32H32.97V36.03C32.97 36.27 32.78 36.46 32.54 36.46C32.3 36.46 32.1 36.27 32.1 36.03V35.32H31.4C31.16 35.32 30.96 35.13 30.96 34.89C30.96 34.65 31.16 34.46 31.4 34.46Z"
        fill="white"
      />
    </svg>
  );
};

export const PersonIcon = () => {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="55" height="55" rx="8" fill="#104581" />
      <path
        d="M27.5 27.5C28.94 27.5 30.32 26.95 31.34 25.96C32.36 24.98 32.93 23.64 32.93 22.25C32.93 20.86 32.36 19.52 31.34 18.54C30.32 17.55 28.94 17 27.5 17C26.06 17 24.68 17.55 23.66 18.54C22.64 19.52 22.07 20.86 22.07 22.25C22.07 23.64 22.64 24.98 23.66 25.96C24.68 26.95 26.06 27.5 27.5 27.5ZM25.56 29.47C21.38 29.47 18 32.74 18 36.78C18 37.45 18.56 38 19.26 38H35.74C36.44 38 37 37.45 37 36.78C37 32.74 33.62 29.47 29.44 29.47H25.56Z"
        fill="white"
      />
    </svg>
  );
};

export const DeviceFillIcon = () => {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="55" height="55" rx="8" fill="#104581" />
      <path
        d="M27.1 35.75C28.71 35.75 30.29 35.28 31.63 34.39L30.93 36.72C30.83 37.07 30.61 37.38 30.32 37.6C30.03 37.82 29.67 37.94 29.31 37.94H24.9C24.54 37.94 24.18 37.82 23.89 37.6C23.6 37.38 23.38 37.07 23.28 36.72L22.58 34.39C23.92 35.28 25.49 35.75 27.1 35.75Z"
        fill="white"
      />
      <path
        d="M27.1 19.19C25.49 19.19 23.92 19.66 22.58 20.55L23.28 18.22C23.38 17.87 23.6 17.56 23.89 17.34C24.18 17.12 24.54 17 24.9 17H29.31C29.67 17 30.03 17.12 30.32 17.34C30.61 17.56 30.83 17.87 30.93 18.22L31.63 20.55C30.29 19.66 28.71 19.19 27.1 19.19Z"
        fill="white"
      />
      <path
        d="M27.1 20.17C25.66 20.17 24.25 20.59 23.05 21.4C21.85 22.2 20.91 23.34 20.36 24.67C19.8 26.01 19.66 27.48 19.94 28.89C20.22 30.31 20.92 31.61 21.94 32.63C22.96 33.66 24.26 34.35 25.68 34.63C27.1 34.92 28.57 34.77 29.9 34.22C31.23 33.67 32.38 32.73 33.18 31.53C33.98 30.33 34.41 28.91 34.41 27.47C34.41 25.53 33.64 23.68 32.27 22.31C30.9 20.94 29.04 20.17 27.1 20.17Z"
        fill="white"
      />
      <path
        d="M35.87 29.66C35.68 29.66 35.49 29.58 35.35 29.45C35.22 29.31 35.14 29.12 35.14 28.93V26.01C35.14 25.82 35.22 25.63 35.35 25.49C35.49 25.36 35.68 25.28 35.87 25.28C36.06 25.28 36.25 25.36 36.39 25.49C36.52 25.63 36.6 25.82 36.6 26.01V28.93C36.6 29.12 36.52 29.31 36.39 29.45C36.25 29.58 36.06 29.66 35.87 29.66Z"
        fill="white"
      />
    </svg>
  );
};
